import { RegexRule } from '@idm/react-forms';

// Negative lookahead: matches any string that does NOT contain 4+ consecutive identical characters.
// RegexRule is valid when the regex matches, so this rule is valid (passes) when no 4+ repeating chars are found.
// AIM rule: "aaaa" (4 repeats) is invalid; "aaa" (3 repeats) is valid.
const REGEX = /^(?!.*(.)\1\1\1)/i;

class NoRepeatedCharRule extends RegexRule {
  constructor() {
    super(REGEX);
  }

  static get ruleName() {
    return 'no-repeated-chars';
  }

  getDefaultMessage() {
    return 'No more than 3 repeating characters';
  }
}

export default NoRepeatedCharRule;
